export default [{
	titulo: 'Galerias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/galerias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]